const GA_ID = 'G-8SJ17QJ4E5';

function gtag(...args) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag(...args);
}

// Traccia cambio pagina — chiamato ad ogni route change
export function trackPageView(path, title) {
  gtag('config', GA_ID, {
    page_path: path,
    page_title: title,
  });
}

// Traccia evento generico
export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params);
}

// Eventi predefiniti per le CTA principali
export const events = {
  ctaCollabora:   () => trackEvent('cta_click',      { label: 'collabora' }),
  ctaProgetti:    () => trackEvent('cta_click',      { label: 'progetti' }),
  formSubmit:     (params = {}) => trackEvent('form_submit', { form: 'collabora', ...params }),
  projectClick:   (name) => trackEvent('project_click', { project: name }),
  productCta:     (product) => trackEvent('product_cta', { product }),
};
